import { Button, ButtonGroup, Col, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core'

export interface PageHeaderButton {
    label: string
    url?: string
    icon?: string
    variant?: string
    onClick?: any
}

export interface PageHeaderProps {
    header: string | JSX.Element
    buttons?: PageHeaderButton[] | JSX.Element
    icon?: IconName
    iconPrefix?: IconPrefix
    subtitle?: string
    gradient?: string
}

const PageHeader: React.FC<PageHeaderProps> = ({
    header,
    buttons,
    icon,
    iconPrefix = 'fas',
    subtitle,
    gradient = 'linear-gradient(135deg, #0a63ea, #083bb0)',
}) => {
    const navigate = useNavigate()

    return (
        <div className="page-header-modern">
            <div className="page-header-modern__left">
                {icon && (
                    <div
                        className="page-header-modern__icon"
                        style={{ background: gradient }}
                    >
                        <FontAwesomeIcon icon={[iconPrefix, icon]} />
                    </div>
                )}
                <div>
                    <h2 className="page-header-modern__title">{header}</h2>
                    {subtitle && (
                        <p className="page-header-modern__subtitle">
                            {subtitle}
                        </p>
                    )}
                </div>
            </div>
            {buttons && (
                <div className="page-header-modern__actions">
                    <ButtonGroup className="shadow-sm">
                        {Array.isArray(buttons)
                            ? buttons?.map(
                                  (btn: PageHeaderButton, index: number) => (
                                      <Button
                                          key={index}
                                          variant={btn.variant}
                                          size="sm"
                                          onClick={() => {
                                              if (btn.onClick) {
                                                  btn.onClick()
                                              } else {
                                                  navigate(btn.url)
                                              }
                                          }}
                                      >
                                          {btn.icon && (
                                              <FontAwesomeIcon
                                                  icon={btn.icon as IconName}
                                              />
                                          )}
                                          <span className="d-none d-sm-inline-block ms-2">
                                              {btn.label}
                                          </span>
                                      </Button>
                                  )
                              )
                            : buttons}
                    </ButtonGroup>
                </div>
            )}
        </div>
    )
}

export default PageHeader
